module.exports = __webpack_public_path__ + "img/follow-person.51b6b576.png";